import { render, staticRenderFns } from "./fccAnaliseFotos.vue?vue&type=template&id=71a89273"
import script from "./fccAnaliseFotos.vue?vue&type=script&lang=js"
export * from "./fccAnaliseFotos.vue?vue&type=script&lang=js"
import style0 from "./fccAnaliseFotos.vue?vue&type=style&index=0&id=71a89273&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports